import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { OpenZenDeskModule } from '@fantaz/shared/directives/open-zendesk';
import { MaterialModule } from '@fantaz/shared/ui/material';
import { ModalAlertComponent } from './modal-alert.component';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    OpenZenDeskModule,
    MaterialModule,
  ],
  declarations: [ModalAlertComponent],
  exports: [ModalAlertComponent],
})
export class SharedUiModalAlertModule {}
